/**
 * Patch for drizzle-kit defects.
 *
 * Fix syntax error: .default(') -> .default('')
 * This is a drizzle-kit bug that generates invalid TypeScript code.
 */

/**
 * Fix drizzle-kit syntax error where .default(') is generated.
 *
 * @param source - The schema source code
 * @returns Object with fixed text and count of fixes applied
 */
export function patchDrizzleKitDefects(source: string): { text: string; fixed: number } {
  let fixed = 0;

  // Fix syntax error: .default(') -> .default('')
  const text = source.replace(/\.default\('\)/g, () => {
    fixed += 1;
    return `.default('')`;
  });

  return { text, fixed };
}
